import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  email = '';

  navItems = [
    { label: 'Accueil', path: '/home' },
    { label: 'Services', path: '/services' },
    { label: 'Formations', path: '/formations' },
    { label: 'Articles', path: '/articles' },
    { label: 'Contact', path: '/contact' }
  ];

  footerLinks = [
    { label: 'La Morphopsychologie c\'est quoi ?', path: '/morphopsychologie' },
    { label: 'Notre visage parle ?', path: '/visage-parle' },
    { label: 'C.G.V', path: '/cgv' },
    { label: 'Politique de confidentialité', path: '/confidentialite' }
  ];

  socialLinks = [
    { name: 'facebook', icon: 'assets/images/icons/facebook-orange.svg', url: '#' },
    { name: 'x', icon: 'assets/images/icons/x-orange.svg', url: '#' },
    { name: 'instagram', icon: 'assets/images/icons/instagram-orange.svg', url: '#' },
    { name: 'linkedin', icon: 'assets/images/icons/linkedin-orange.svg', url: '#' },
    { name: 'gmail', icon: 'assets/images/icons/google-orange.svg', url: '#' }
  ];

  subscribeToNewsletter() {
    if (this.email) {
      this.email = ''; 
    }
  }
}